var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import notificationService from "src/shared/notification/notification-service";
import { useComponentStoreV2 } from "src/shared/store/component";
import { useBuiltComponent } from "src/shared/store/component-built/composables";
import { confirm } from "src/shared/v-components/ui/message-box";
export const confirmRemoveInstalledComponent = (parameters) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const componentStore = useComponentStoreV2();
    const { builtComponent } = useBuiltComponent(parameters.targetComponentId);
    const nameOfComponentToRemove = ((_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getDisplayName()) || "Component";
    confirm({
        title: `Delete ${nameOfComponentToRemove}`,
        message: `Are you sure you want to delete ${nameOfComponentToRemove}?`,
        confirmButtonText: "Confirm",
        onConfirm: (onSuccess, onError) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (!builtComponent.value) {
                    return;
                }
                yield componentStore.removeComponentFromSocket({
                    campaignId: builtComponent.value.campaign_id,
                    componentId: parameters.componentId,
                    settingName: parameters.settingName,
                    targetComponentId: parameters.targetComponentId,
                });
                notificationService.success(`${nameOfComponentToRemove} deleted successfully`);
                onSuccess();
            }
            catch (e) {
                notificationService.error(e);
                onError();
            }
        }),
    });
});
